import { faBriefcase, faDollarSign, faEllipsisVertical, faUser, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Nav, Row, Tab } from 'react-bootstrap';
import { UnauthorizedTableState } from '../../../../pages/UnauthorizedTableState';
import { formatDate, formatToINR, putCommaInLeadsValue } from '../../../../Utils/helpers/commonhelper';
import { DescriptionTooltip } from '../../../../Utils/helpers/descriptionTooltip/DescriptionTooltip';
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png"
import { CreateDeal } from '../../../deals/CreateDeal';
import { CreateLead } from '../../../Leads/CreateLead';
import { UpdateDeal } from '../../../deals/UpdateDeal';
import DeleteModal from '../../../DeleteModal';
import useLocalStorageState from 'use-local-storage-state';
import { toast } from 'sonner';
import { DeleteRequest, GetRequest } from '../../../../Utils/hooks/ApiHandler';
import { useNavigate } from 'react-router-dom';
import { DealDetails } from '../../../deals/DealDetails';
import { LeadsDetails } from '../../leads/LeadsDetails';

export const ContactProspectsInfo = ({ contactId, contactLeads, fetchContactDetails, contactDetails, styles }) => {

    const [customer, setCustomer] = useLocalStorageState("customer");
    const navigate = useNavigate();
    // Extract tokens from session
    const customerId = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token,
    };
    const extras = { customer, setCustomer, rf, navigate };

    // permission setup for conntacts
    const permission = customer.customer_details?.permission
    const user_type = Number(customer.customer_details?.user_type)
    // permission for lead and deal
    const leadPermission = permission?.filter(c => c.module_name === "leads")
    const dealPermission = permission?.filter(c => c.module_name === "deals")

    const leadGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.delete)) : true,
    }
    const dealGrant = {
        isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.delete)) : true,
    }
    const [loading, setLoading] = useState(false)

    const [openRow, setOpenRow] = useState(null);
    const [selectedDealId, setSelectedDealId] = useState(null);
    const [selectedLeadId, setSelectedLeadId] = useState(null);

    const [shows, setShow] = useState(false);
    const [showDealDetails, setShowDealDetails] = useState(false);
    const [showLeadDetails, setShowLeadDetails] = useState(false);
    // show deal offcanvas
    const [showAddDealOffcanvas, setShowAddDealOffcanvas] = useState(false);
    // update or edit deal offcanvas state
    const [showUpdateDealOffcanvas, setShowUpdateDealOffcanvas] = useState(false)
    // lead and deal id for edit and delete use
    const [editLeadId, setEditLeadId] = useState(null)
    const [editDealId, setEditDealId] = useState(null)
    // deal data set
    const [deals, setDeals] = useState([])
    const [contactDeals, setContactDeals] = useState([])
    // leads and deals status
    const [dealStatus, setDealStatus] = useState({})
    const [leadsStatus, setLeadsStatus] = useState({});
    const [leads, setLeads] = useState([]);
    // set deals card data
    const [dealsCardData, setDealsCardData] = useState([])
    // stage id for deal set it null
    const [selectedStageId, setSelectedStageId] = useState(null)
    // delete dealId
    const [showDealDeleteModal, setShowDealDeleteModal] = useState(false)
    // delete leadId
    const [showLeadDeleteModal, setShowLeadDeleteModal] = useState(false)
    // open delete modal to delete lead
    const [deleteLeadId, setDeleteLeadId] = useState(null)
    //open delete mode to delete deal
    const [deleteDealId, setDeleteDealId] = useState(null)


    // open lead offcanvas
    const [showAddLeadsOffcanvas, setShowAddLeadsOffcanvas] = useState(false);

    // associated leads and deals state
    const [associatedDeals, setAssociatedDeals] = useState(false);


    const fetchLeads_status = async () => {
        try {
            const endpoint =
                leadsStatus === "won"
                    ? `contacts/fetchWonLeads/${customerId}/${contactId}`
                    : leadsStatus === "lost"
                        ? `contacts/fetchLostLeads/${customerId}/${contactId}`
                        : leadsStatus === "unqualified"
                            ? `contacts/fetchUnqualifiedLeads/${customerId}/${contactId}`
                            : "";
            setLoading(true); // Set loading to true when starting
            const res = await GetRequest(endpoint, { headers }, extras);
            setLeads(res.data);
            setLoading(false); // Set loading to false when done
        } catch (err) {
            setLoading(false); // Ensure loading is false even on error
        }
    };

    useEffect(() => {
        fetchLeads_status();
    }, [leadsStatus]);

    const fetchDealsByStatus = async () => {
        try {

            const endpoint =
                dealStatus === "won" ?
                    `contacts/getDealsBasedOnStatus/${contactId}/${customerId}/won`
                    : dealStatus === "lost" ?
                        `contacts/getDealsBasedOnStatus/${contactId}/${customerId}/lost`
                        : dealStatus === "unqualified" ?
                            `contacts/getDealsBasedOnStatus/${contactId}/${customerId}/unqualified`
                            : ""
            const res = await GetRequest(endpoint,
                { headers },
                { extras }
            )
            // setDealStatus(res.data)
            setDeals(res?.data)
            // setContactDeals([])
            // setLoading(false)

        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        fetchDealsByStatus()
    }, [dealStatus])


    const fetchAllDeals = async () => {
        try {
            const res = await GetRequest(
                `contacts/fetchContactAllDeals/${contactId}/${customerId}`,
                { headers },
                { extras }
            );
            setContactDeals(res.data.allDeals);
            setDealsCardData(res.data)
            setDeals([])
        } catch (error) { }
    };


    const handleClose = () => {
        setShow(false);
        setShowDealDetails(false);
        setShowLeadDetails(false)
    };


    // function to close edit deals canvas
    const handleUpdateDealClose = () => {
        setShowUpdateDealOffcanvas(false)
        setSelectedStageId(null)
    }

    const handleOnLeadClick = (val) => {
        setShowLeadDetails(true);
        setSelectedLeadId(val?.id);
    };

    const handleDealDetailPage = (val) => {
        setSelectedDealId(val?.id);
        setShowDealDetails(true);
    };

    // function to delete leads
    const handleDeleteConfirm = async () => {
        setLoading(true)
        try {
            const response = await DeleteRequest(`lead/deleteLead/${deleteLeadId}/${customer?.customer_details?.id}`,
                { headers },
                extras)

            if (response?.status === "success") {
                toast.success("Lead deleted successfully")
                setLoading(false)
                await fetchContactDetails();
            } else {
                setLoading(false)
                toast.error(response?.message || "Failed to delete lead")
            }
        } catch (error) {
            setLoading(false)
            toast.error("An error occurred while deleting lead")
        } finally {
            setLoading(false)
            setShowLeadDeleteModal(false)
            setDeleteLeadId(null)
        }
    }

    // function to delete deal
    const handleDeleteDealConfirm = async () => {
        setLoading(true)
        try {
            const response = await DeleteRequest(`deals/deleteDeal/${deleteDealId}/${customer.customer_details?.id}`,
                { headers }, extras
            )

            if (response?.status === "success") {
                setLoading(false)
                toast.success(response.message)
                await fetchAllDeals()
            } else {
                setLoading(false)
                toast.error(response?.message || "Failed to delete Deal")
            }
        } catch (error) {
            setLoading(false)
            toast.error("An error occurred while deleting deal")
        } finally {
            setLoading(false)
            setShowDealDeleteModal(false)
            setDeleteDealId(null)
        }
    }
    return (
        <>
            <Row
                className="w-100 ms-0 mt-2 ps-0 pe-2"
                style={{ minHeight: "390px" }}
            >
                <Col
                    md={12}
                    className="tab-container bg-white ps-0 pe-0"
                    style={styles.tabContainer}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex gap-1 align-items-center mx-3">
                            <h4
                                style={{
                                    fontSize: associatedDeals ? 15 : 20,
                                    fontWeight: 300,
                                    color: associatedDeals ? "gray" : "black",
                                    cursor: "pointer",
                                }}
                                className="my-3 "
                                onClick={() => {
                                    setAssociatedDeals(false);
                                }}
                            >
                                Associated Leads
                            </h4>
                            <span>|</span>
                            <h4
                                style={{
                                    fontSize: associatedDeals ? 20 : 15,
                                    fontWeight: 300,
                                    color: associatedDeals ? "black" : "gray",
                                    cursor: "pointer",
                                }}
                                className="my-3 "
                                onClick={() => {
                                    setAssociatedDeals(true);
                                    fetchAllDeals();
                                }}
                            >
                                Associated Deals
                            </h4>
                        </div>
                        {/* //leads div for add and listing leads */}
                        {!associatedDeals && (
                            <div
                                className="d-flex align-items-center gap-2 pe-3"
                            //  style={{display:associatedDeals ? "none" : "block"}}
                            >
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: 'rgb(63, 151, 253)'
                                    }}
                                    onClick={() => {
                                        if (!leadGrant.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        setShowAddLeadsOffcanvas(true);
                                    }}
                                >
                                    Add Lead
                                </p>
                                <p
                                    className="mb-0 mx-2 "
                                    style={{
                                        borderRight: "1px solid #c9c9c9",
                                        height: 19,
                                    }}
                                ></p>
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: "rgb(63, 151, 253)"
                                    }}
                                    onClick={() => {
                                        if (!leadGrant.isView) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        window.open(
                                            `${window.location.origin}/deals?module=contact&id=${contactId}`,
                                            "_blank"
                                        )
                                    }
                                    }
                                >
                                    List All Leads
                                </p>
                            </div>
                        )}

                        {/* // deals div for add and listing deals */}
                        {associatedDeals && (
                            <div
                                className="d-flex align-items-center gap-2 pe-3"
                            // style={{display:associatedDeals?"block" : "none"}}
                            >
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: "rgb(63, 151, 253)"
                                    }}
                                    onClick={() => {
                                        if (!dealGrant.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        };
                                        setShowAddDealOffcanvas(true)
                                    }}
                                >
                                    Add Deal
                                </p>
                                <p
                                    className="mb-0 mx-2 "
                                    style={{
                                        borderRight: "1px solid #c9c9c9",
                                        height: 19,
                                    }}
                                ></p>
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: "rgb(63, 151, 253)",
                                    }}
                                    onClick={() => {
                                        if (!dealGrant.isView) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        window.open(
                                            `${window.location.origin}/deal?module=contact&id=${contactId}`,
                                            "_blank"
                                        )
                                    }}
                                >
                                    List All Deals
                                </p>
                            </div>
                        )}
                    </div>
                    {associatedDeals ? (
                        // deals tab container
                        <Tab.Container defaultActiveKey="Communications">
                            <Nav
                                variant="pills"
                                className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                            >
                                <Nav.Item
                                    className="me-0"
                                    style={{ minWidth: "17%" }}
                                    onClick={() => {
                                        // setLeads([]);
                                        setDealStatus("")
                                        fetchAllDeals()
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Communications"
                                        style={styles.navLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            All Deals{" "}
                                            <FontAwesomeIcon icon={faDollarSign} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.AllCount || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        dealsCardData?.total_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%", cursor: dealsCardData?.won == 0 ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => {
                                        if (dealsCardData?.won == 0) {
                                            return;
                                        } else {
                                            setContactDeals([])
                                            setDealStatus("won");
                                            fetchDealsByStatus();
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Locations"
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Won Deals{" "}
                                            <FontAwesomeIcon icon={faBriefcase} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.won || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p
                                                    style={{
                                                        color: "white",
                                                        fontWeight: 400,
                                                    }}
                                                >

                                                    {formatToINR(
                                                        dealsCardData?.won_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%", cursor: dealsCardData?.lost == 0 ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => {
                                        if (dealsCardData?.lost == 0) {
                                            return;
                                        } else {
                                            setContactDeals([])
                                            setDealStatus("lost");
                                            fetchDealsByStatus();
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Socials"
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Lost Deals <FontAwesomeIcon icon={faUser} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.lost || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        dealsCardData?.lost_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%", cursor: dealsCardData?.unqualified == 0 ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => {
                                        if (dealsCardData?.unqualified == 0) {
                                            return;
                                        } else {
                                            setContactDeals([])
                                            setDealStatus("unqualified");
                                            fetchDealsByStatus()
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Socials"
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Unqualified Deals{" "}
                                            <FontAwesomeIcon icon={faUserLock} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.unqualified || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0 text-white"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        dealsCardData?.unqualified_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            {/* deals table mapping */}
                            <Tab.Content>
                                <Tab.Pane
                                    className="p-0 pt-3 pb-3"
                                    eventKey="Communications"
                                    style={{
                                        border: "none",
                                        animation: "cardEntry 1s ease-out forwards",
                                    }}
                                >
                                    <div className="table-responsive" style={{ maxHeight: "15rem", minHeight: '15rem' }}>
                                        <table className="table Communications listStyleForContact"
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                                            }}
                                            style={{ scrollbarWidth: 'thin' }}>
                                            <thead style={{ zIndex: 99 }}>

                                                <tr>
                                                    <th style={{ borderRadius: 0 }}>#</th>
                                                    {/* <th>Lead Title</th> */}
                                                    <th>Owner</th>
                                                    <th>Requirement</th>
                                                    <th>Budget</th>
                                                    <th>Closure Date</th>
                                                    <th>Pipeline</th>
                                                    <th>Stage</th>
                                                    <th>Status</th>
                                                    <th style={{ borderRadius: 0 }}>
                                                        Created on
                                                    </th>
                                                    <th
                                                        className="lastactionTd"
                                                        style={styles.lastdStyle}
                                                    ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dealGrant.isView ?
                                                        deals?.length === 0 ?
                                                            contactDeals?.length > 0
                                                                ? contactDeals?.map(
                                                                    (val, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                {/* <td>?</td> */}
                                                                                <td
                                                                                    className="text-primary"
                                                                                    onClick={() => {
                                                                                        handleDealDetailPage(val);
                                                                                    }}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    {val.owner_name || "-"}
                                                                                </td>
                                                                                <td>
                                                                                    {val.requirement.length >
                                                                                        20 ? (
                                                                                        <DescriptionTooltip
                                                                                            text={val.requirement}
                                                                                            maxLength={30}
                                                                                        />
                                                                                    ) : (
                                                                                        val.requirement
                                                                                    )}
                                                                                </td>
                                                                                {/* <td>{val.owner_name ? val.owner_name : "-"}</td> */}
                                                                                <td>
                                                                                    <span
                                                                                        className="mb-0 fs-12"
                                                                                        style={{
                                                                                            color: "#17c417 ",
                                                                                            fontWeight: 500,
                                                                                        }}
                                                                                    >
                                                                                        {putCommaInLeadsValue(
                                                                                            JSON.parse(val?.product_services)?.reduce((sum, obj) => sum + parseFloat(obj.budget || 0), 0)
                                                                                        )}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    {formatDate(val.expected_closure_date) || "-"}
                                                                                </td>
                                                                                <td>
                                                                                    {val.pipeline_name
                                                                                        ? val.pipeline_name
                                                                                        : "-"}
                                                                                </td>
                                                                                <td>{val.stage_name}</td>
                                                                                <td>
                                                                                    <div>
                                                                                        {val.deal_status
                                                                                            ? val.deal_status
                                                                                            : "-"}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    {formatDate(val.created_at)}
                                                                                </td>
                                                                                <td
                                                                                    className="lastactionTd"
                                                                                    style={{
                                                                                        ...styles.lastdStyle,
                                                                                        zIndex: openRow === val.id ? 11 : "auto",
                                                                                    }}
                                                                                >
                                                                                    <div className="endTdDiv">
                                                                                        <Dropdown
                                                                                            as="div"
                                                                                            className="dropdownsWithoutToggle"
                                                                                            onToggle={(isOpen) => setOpenRow(isOpen ? val.id : null)}
                                                                                        >
                                                                                            <Dropdown.Toggle
                                                                                                as={Nav.Link}
                                                                                                className="header-link"
                                                                                            >
                                                                                                <FontAwesomeIcon
                                                                                                    icon={faEllipsisVertical}
                                                                                                    style={{
                                                                                                        fontSize: "15px",
                                                                                                        width: "20px",
                                                                                                        color: "#536485",
                                                                                                    }}
                                                                                                />
                                                                                            </Dropdown.Toggle>
                                                                                            <Dropdown.Menu

                                                                                                align={"end"}
                                                                                                style={{
                                                                                                    width: "8rem",
                                                                                                    inset: "0px auto auto 0px",
                                                                                                    boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                                                                                    position: "absolute",
                                                                                                    marginTop: "-22px",
                                                                                                    marginRight: '25px',
                                                                                                    minWidth: "3rem",
                                                                                                }}
                                                                                            >
                                                                                                <Dropdown.Item
                                                                                                    style={{
                                                                                                        fontSize: "12px",
                                                                                                        padding: "4px 21px",
                                                                                                    }}
                                                                                                    className="d-flex align-items-center btn"
                                                                                                    onClick={() => {
                                                                                                        setEditDealId(val.id)
                                                                                                        setShowUpdateDealOffcanvas(true)
                                                                                                    }}

                                                                                                >
                                                                                                    {" "}
                                                                                                    Edit{" "}
                                                                                                </Dropdown.Item>
                                                                                                <Dropdown.Item
                                                                                                    style={{
                                                                                                        fontSize: "12px",
                                                                                                        padding: "4px 21px",
                                                                                                    }}

                                                                                                    className="d-flex align-items-center btn"
                                                                                                    onClick={() => {
                                                                                                        setDeleteDealId(val.id);
                                                                                                        setShowDealDeleteModal(true)
                                                                                                    }}

                                                                                                >
                                                                                                    {" "}
                                                                                                    Delete{" "}
                                                                                                </Dropdown.Item>
                                                                                            </Dropdown.Menu>
                                                                                        </Dropdown>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    }
                                                                )
                                                                :
                                                                <div
                                                                    class="d-flex justify-content-center align-items-center"
                                                                    style={{ position: "absolute", left: "40%" }}
                                                                >
                                                                    <img
                                                                        src={nodata}
                                                                        alt=""
                                                                        style={{ width: "12rem", marginTop: "0" }}
                                                                    />
                                                                </div>
                                                            : deals && deals?.map((val, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{val.owner_name ? val.owner_name : "-"}</td>
                                                                        <td>
                                                                            {" "}
                                                                            {val.requirement.length >
                                                                                20 ? (
                                                                                <DescriptionTooltip
                                                                                    text={val.requirement}
                                                                                    maxLength={30}
                                                                                />
                                                                            ) : (
                                                                                val.requirement
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <p
                                                                                className="mb-0 fs-12"
                                                                                style={{
                                                                                    color: "#17c417 ",
                                                                                    fontWeight: 500,
                                                                                }}
                                                                            >
                                                                                {putCommaInLeadsValue(
                                                                                    JSON.parse(val.product_services)?.reduce((sum, obj) => sum + parseFloat(obj.budget || 0), 0)
                                                                                )}
                                                                            </p>
                                                                        </td>
                                                                        <td>{val.expected_closure_date}</td>
                                                                        <td>
                                                                            {val.pipeline_name}
                                                                        </td>
                                                                        <td>{val.stage_name}</td>

                                                                        <td>
                                                                            {val.deal_status
                                                                                ? val.deal_status
                                                                                : "-"}
                                                                        </td>
                                                                        <td>
                                                                            {formatDate(val.created_at)}
                                                                        </td>
                                                                        <td>{val.requirement}</td>
                                                                        <td
                                                                            className="lastactionTd"
                                                                            style={{
                                                                                ...styles.lastdStyle, // spread karo object ko
                                                                                zIndex: openRow === val.id ? 11 : "auto",
                                                                            }}
                                                                        >
                                                                            <div className="endTdDiv">
                                                                                <Dropdown
                                                                                    as="div"
                                                                                    className="dropdownsWithoutToggle"
                                                                                    onToggle={(isOpen) => setOpenRow(isOpen ? val.id : null)}
                                                                                >
                                                                                    <Dropdown.Toggle
                                                                                        as={Nav.Link}
                                                                                        className="header-link"
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={faEllipsisVertical}
                                                                                            style={{
                                                                                                fontSize: "15px",
                                                                                                width: "20px",
                                                                                                color: "#536485",
                                                                                            }}
                                                                                        />
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu

                                                                                        align={"end"}
                                                                                        style={{
                                                                                            width: "8rem",
                                                                                            inset: "0px auto auto 0px",
                                                                                            boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                                                                            position: "absolute",
                                                                                            marginTop: "-22px",
                                                                                            marginRight: '25px',
                                                                                            minWidth: "3rem",
                                                                                        }}
                                                                                    >
                                                                                        <Dropdown.Item
                                                                                            style={{
                                                                                                fontSize: "12px",
                                                                                                padding: "4px 21px",
                                                                                            }}
                                                                                            className="d-flex align-items-center btn"
                                                                                            onClick={() => {
                                                                                                setEditDealId(val.id)
                                                                                                setShowUpdateDealOffcanvas(true)
                                                                                            }}
                                                                                        >
                                                                                            {" "}
                                                                                            Edit{" "}
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item
                                                                                            style={{
                                                                                                fontSize: "12px",
                                                                                                padding: "4px 21px",
                                                                                            }}

                                                                                            className="d-flex align-items-center btn"
                                                                                            onClick={() => {
                                                                                                setDeleteDealId(val.id);
                                                                                                setShowDealDeleteModal(true)
                                                                                            }}
                                                                                        >
                                                                                            {" "}
                                                                                            Delete{" "}
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        :
                                                        <td colSpan={10}  >
                                                            <UnauthorizedTableState tabName={"Deals"} />
                                                        </td>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane
                                    eventKey="Locations"
                                    style={{
                                        border: "none",
                                        animation: "cardEntry 1s ease-out forwards",
                                    }}
                                ></Tab.Pane>
                                <Tab.Pane
                                    eventKey="Socials"
                                    style={{
                                        border: "none",
                                        animation: "cardEntry 1s ease-out forwards",
                                    }}
                                ></Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                        // deals tab container end
                    ) : (
                        // leads tab container
                        <Tab.Container defaultActiveKey="Communications">
                            <Nav
                                variant="pills"
                                className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                            >
                                <Nav.Item
                                    className="me-0"
                                    style={{ minWidth: "17%" }}
                                    onClick={() => {
                                        setLeads([]);
                                        setLeadsStatus({});
                                        fetchContactDetails();
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Communications"
                                        style={styles.navLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white" >
                                            All Leads{" "}
                                            <FontAwesomeIcon icon={faDollarSign} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.leads?.length || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue || "0"
                                                    )
                                                    }
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* won leads */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%",
                                        cursor:
                                            contactDetails?.total_won_leads === 0
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={() => {
                                        if (
                                            contactDetails?.total_won_leads === 0
                                        ) {
                                            return;
                                        } else {
                                            setLeadsStatus("won");
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Locations"
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Won Leads{" "}
                                            <FontAwesomeIcon icon={faBriefcase} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.total_won_leads || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue_won || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%",
                                        cursor:
                                            contactDetails?.total_lost_leads == 0
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={() => {
                                        if (
                                            contactDetails?.total_lost_leads == 0
                                        ) {
                                            return;
                                        } else {
                                            setLeadsStatus("lost");
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Socials"
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Lost Leads <FontAwesomeIcon icon={faUser} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.total_lost_leads || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue_lost || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%",
                                        cursor:
                                            contactDetails?.total_unqualified_leads == 0
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={() => {
                                        if (
                                            contactDetails?.total_unqualified_leads == 0
                                        ) {
                                            return;
                                        } else {
                                            setLeadsStatus("unqualified");
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        eventKey="Socials"
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Unqualified Leads{" "}
                                            <FontAwesomeIcon icon={faUserLock} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.total_unqualified_leads || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue_unqualified ||
                                                        "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane
                                    className="p-0 pt-3 pb-3"
                                    eventKey="Communications"
                                    style={{
                                        border: "none",
                                        animation: "cardEntry 1s ease-out forwards",
                                    }}
                                >
                                    <div className="table-responsive" style={{ maxHeight: "15rem", minHeight: '15rem' }}>
                                        <table className="table Communications listStyleForContact"
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                                            }}
                                            style={{ scrollbarWidth: "thin" }}>
                                            <thead style={{ zIndex: 99 }}>
                                                <tr>
                                                    <th style={{ borderRadius: 0 }}>#</th>
                                                    {/* <th>Lead Title</th> */}
                                                    <th>Lead owner</th>
                                                    <th >Requirement</th>
                                                    <th>Budget</th>
                                                    <th>Closure Date</th>
                                                    <th>Pipeline</th>
                                                    <th>Stage</th>
                                                    <th>status</th>
                                                    <th style={{ borderRadius: 0 }}>
                                                        Created On
                                                    </th>
                                                    <th
                                                        className="lastactionTd"
                                                        style={styles.lastdStyle}
                                                    ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    leadGrant.isView ?
                                                        leads?.length === 0
                                                            ? contactDetails?.leads?.length > 0 ?
                                                                contactDetails?.leads?.map(
                                                                    (val, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                <td
                                                                                    className="text-primary"
                                                                                    onClick={() => {
                                                                                        handleOnLeadClick(val);
                                                                                    }}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    {val.owner_name}
                                                                                </td>
                                                                                <td>
                                                                                    {" "}
                                                                                    {val.requirement.length >
                                                                                        20 ? (
                                                                                        <DescriptionTooltip
                                                                                            text={val.requirement}
                                                                                            maxLength={30}
                                                                                        />
                                                                                    ) : (
                                                                                        val.requirement
                                                                                    )}
                                                                                </td>
                                                                                {/* <td>{val.owner_name}</td> */}
                                                                                <td>
                                                                                    <div
                                                                                        className="mb-0 fs-12"
                                                                                        style={{
                                                                                            color: "#17c417 ",
                                                                                            fontWeight: 500,
                                                                                        }}
                                                                                    >
                                                                                        {val?.product_services === "null" ? "-" : putCommaInLeadsValue(
                                                                                            JSON.parse(
                                                                                                val.product_services
                                                                                            )?.reduce(
                                                                                                (sum, obj) =>
                                                                                                    sum +
                                                                                                    parseFloat(
                                                                                                        obj.budget || 0
                                                                                                    ),
                                                                                                0
                                                                                            )
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    {formatDate(
                                                                                        val.expected_closure_date
                                                                                    ) || "-"}
                                                                                </td>
                                                                                <td>
                                                                                    {val.pipeline_name
                                                                                        ? val.pipeline_name
                                                                                        : "-"}
                                                                                </td>
                                                                                <td>{val.stage_name}</td>
                                                                                <td>
                                                                                    <div>
                                                                                        {val.lead_status
                                                                                            ? val.lead_status
                                                                                            : "-"}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    {formatDate(val.created_at)}
                                                                                </td>
                                                                                <td
                                                                                    className="lastactionTd"
                                                                                    style={{
                                                                                        ...styles.lastdStyle,
                                                                                        zIndex:
                                                                                            openRow === val.id
                                                                                                ? 11
                                                                                                : "auto",
                                                                                    }}
                                                                                >
                                                                                    <div className="endTdDiv">
                                                                                        <Dropdown
                                                                                            as="div"
                                                                                            className="dropdownsWithoutToggle"
                                                                                            onToggle={(isOpen) =>
                                                                                                setOpenRow(
                                                                                                    isOpen
                                                                                                        ? val.id
                                                                                                        : null
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <Dropdown.Toggle
                                                                                                as={Nav.Link}
                                                                                                className="header-link"
                                                                                            >
                                                                                                <FontAwesomeIcon
                                                                                                    icon={
                                                                                                        faEllipsisVertical
                                                                                                    }
                                                                                                    style={{
                                                                                                        fontSize: "15px",
                                                                                                        width: "20px",
                                                                                                        color: "#536485",
                                                                                                    }}
                                                                                                />
                                                                                            </Dropdown.Toggle>
                                                                                            <Dropdown.Menu
                                                                                                align={"end"}
                                                                                                style={{
                                                                                                    width: "8rem",
                                                                                                    inset:
                                                                                                        "0px auto auto 0px",
                                                                                                    boxShadow:
                                                                                                        "rgb(215, 215, 215) 0px 0px 15px",
                                                                                                    position:
                                                                                                        "absolute",
                                                                                                    marginTop: "-22px",
                                                                                                    marginRight: "25px",
                                                                                                    minWidth: "3rem",
                                                                                                }}
                                                                                            >
                                                                                                <Dropdown.Item
                                                                                                    style={{
                                                                                                        fontSize: "12px",
                                                                                                        padding:
                                                                                                            "4px 21px",
                                                                                                    }}
                                                                                                    className="d-flex align-items-center btn"
                                                                                                    onClick={() => {
                                                                                                        setEditLeadId(val.id)
                                                                                                        setShowAddLeadsOffcanvas(true);
                                                                                                    }}
                                                                                                >
                                                                                                    {" "}
                                                                                                    Edit{" "}
                                                                                                </Dropdown.Item>
                                                                                                <Dropdown.Item
                                                                                                    style={{
                                                                                                        fontSize: "12px",
                                                                                                        padding:
                                                                                                            "4px 21px",
                                                                                                    }}
                                                                                                    className="d-flex align-items-center btn"
                                                                                                    onClick={() => {
                                                                                                        setDeleteLeadId(val.id)
                                                                                                        setShowLeadDeleteModal(true);
                                                                                                    }}
                                                                                                >
                                                                                                    {" "}
                                                                                                    Delete{" "}
                                                                                                </Dropdown.Item>
                                                                                            </Dropdown.Menu>
                                                                                        </Dropdown>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    }
                                                                )
                                                                :
                                                                <div
                                                                    class="d-flex justify-content-center align-items-center"
                                                                    style={{ position: "absolute", left: "40%" }}
                                                                >
                                                                    <img
                                                                        src={nodata}
                                                                        alt=""
                                                                        style={{ width: "12rem", marginTop: "0" }}
                                                                    />
                                                                </div>
                                                            : leads && leads?.map((val, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{val.owner_name}</td>
                                                                        <td>
                                                                            {val.requirement.length >
                                                                                20 ? (
                                                                                <DescriptionTooltip
                                                                                    text={val.requirement}
                                                                                    maxLength={30}
                                                                                />
                                                                            ) : (
                                                                                val.requirement
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <span
                                                                                className="mb-0 fs-12"
                                                                                style={{
                                                                                    color: "#17c417 ",
                                                                                    fontWeight: 500,
                                                                                }}
                                                                            >
                                                                                {val.product_services ===
                                                                                    "null"
                                                                                    ? "-"
                                                                                    : putCommaInLeadsValue(
                                                                                        JSON.parse(
                                                                                            val.product_services,
                                                                                        ).reduce(
                                                                                            (sum, obj) =>
                                                                                                sum +
                                                                                                parseFloat(
                                                                                                    obj.budget || 0,
                                                                                                ),
                                                                                            0,
                                                                                        ),
                                                                                    )}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            {formatDate(
                                                                                val.expected_closure_date,
                                                                            )}
                                                                        </td>
                                                                        <td>{val.pipeline_name}</td>
                                                                        <td>{val.stage_name}</td>
                                                                        <td>
                                                                            {val.lead_status
                                                                                ? val.lead_status
                                                                                : "-"}
                                                                        </td>
                                                                        <td>
                                                                            {formatDate(val.created_at)}
                                                                        </td>

                                                                        <td
                                                                            className="lastactionTd"
                                                                            style={{
                                                                                ...styles.lastdStyle, // spread karo object ko
                                                                                zIndex:
                                                                                    openRow === val.id
                                                                                        ? 11
                                                                                        : "auto",
                                                                            }}
                                                                        >
                                                                            <div className="endTdDiv">
                                                                                <Dropdown
                                                                                    as="div"
                                                                                    className="dropdownsWithoutToggle"
                                                                                    onToggle={(isOpen) =>
                                                                                        setOpenRow(
                                                                                            isOpen
                                                                                                ? val.id
                                                                                                : null,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Dropdown.Toggle
                                                                                        as={Nav.Link}
                                                                                        className="header-link"
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={
                                                                                                faEllipsisVertical
                                                                                            }
                                                                                            style={{
                                                                                                fontSize: "15px",
                                                                                                width: "20px",
                                                                                                color: "#536485",
                                                                                            }}
                                                                                        />
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu
                                                                                        align={"end"}
                                                                                        style={{
                                                                                            width: "8rem",
                                                                                            inset:
                                                                                                "0px auto auto 0px",
                                                                                            boxShadow:
                                                                                                "rgb(215, 215, 215) 0px 0px 15px",
                                                                                            position: "absolute",
                                                                                            marginTop: "-22px",
                                                                                            marginRight: "25px",
                                                                                            minWidth: "3rem",
                                                                                        }}
                                                                                    >
                                                                                        <Dropdown.Item
                                                                                            style={{
                                                                                                fontSize: "12px",
                                                                                                padding: "4px 21px",
                                                                                            }}
                                                                                            className="d-flex align-items-center btn"
                                                                                            onClick={() => {
                                                                                                setEditLeadId(
                                                                                                    val.id,
                                                                                                )
                                                                                                setShowAddLeadsOffcanvas(
                                                                                                    true,
                                                                                                )
                                                                                            }}
                                                                                        >
                                                                                            {" "}
                                                                                            Edit{" "}
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item
                                                                                            style={{
                                                                                                fontSize: "12px",
                                                                                                padding: "4px 21px",
                                                                                            }}
                                                                                            className="d-flex align-items-center btn"
                                                                                            onClick={() => {
                                                                                                setDeleteLeadId(
                                                                                                    val.id,
                                                                                                )
                                                                                                setShowLeadDeleteModal(
                                                                                                    true,
                                                                                                )
                                                                                            }}
                                                                                        >
                                                                                            {" "}
                                                                                            Delete{" "}
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        :

                                                        <td colSpan={10}  >
                                                            <UnauthorizedTableState tabName={"Leads"} />
                                                        </td>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane
                                    eventKey="Locations"
                                    style={{
                                        border: "none",
                                        animation: "cardEntry 1s ease-out forwards",
                                    }}
                                ></Tab.Pane>
                                <Tab.Pane
                                    eventKey="Socials"
                                    style={{
                                        border: "none",
                                        animation: "cardEntry 1s ease-out forwards",
                                    }}
                                ></Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    )}
                </Col>
            </Row>
            {/* show add leads offcanvas */}
            <CreateLead
                show={showAddLeadsOffcanvas}
                onHide={() => {
                    setEditLeadId(null)
                    setShowAddLeadsOffcanvas(false)
                }}
                onLeadCreated={fetchContactDetails}
                onLeadUpdated={fetchContactDetails}
                moduleName="contact"
                contactId={contactId}
                editId={editLeadId}
            />

            {/* // show add deal offcanvas */}
            {showAddDealOffcanvas && (
                <CreateDeal
                    show={showAddDealOffcanvas}
                    onHide={() => {
                        setShowAddDealOffcanvas(false);
                    }}
                    moduleName="contact"
                    id={contactId}
                    onLeadCreated={fetchAllDeals}
                    setDealAdd={setDeals}
                />
            )}

            {/* edit deal */}
            <UpdateDeal
                show={showUpdateDealOffcanvas}
                onHide={handleUpdateDealClose}
                editId={editDealId}
                onLeadUpdated={fetchAllDeals}
            />


            {/* delete leads */}
            {showLeadDeleteModal &&
                <DeleteModal
                    show={setShowLeadDeleteModal}
                    onClose={() => {
                        setShowLeadDeleteModal(false);
                        setDeleteLeadId(null)
                    }}
                    onConfirm={handleDeleteConfirm}
                    isLoading={loading}
                    message="Are you sure you want to delete this lead?"
                />
            }

            {/* delete deals */}
            {showDealDeleteModal &&
                <DeleteModal
                    show={showDealDeleteModal}
                    onClose={() => {
                        setDeleteDealId(null);
                        setShowDealDeleteModal(false)
                    }}
                    onConfirm={handleDeleteDealConfirm}
                    isLoading={loading}
                    message="Are you sure you want to delete this lead?"
                />
            }

            {
                showDealDetails && (
                    <DealDetails
                        show={showDealDetails}
                        onClose={handleClose}
                        dealId={selectedDealId}
                    />
                )
            }
            {
                showLeadDetails && (
                    <LeadsDetails
                        show={showLeadDetails}
                        onClose={handleClose}
                        leadId={selectedLeadId}
                    />
                )

            }
        </>
    )
}
